import { render, staticRenderFns } from "./ValidateToken.vue?vue&type=template&id=513d0c50&"
import script from "./ValidateToken.vue?vue&type=script&lang=js&"
export * from "./ValidateToken.vue?vue&type=script&lang=js&"
import style0 from "./ValidateToken.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports